/* eslint-disable no-undef */

import { axiosClient } from "./client";

export const getHomeImages = () => {
  return axiosClient.get(`api/page-config/`);
};
